import * as React from "react";
import PropTypes from "prop-types";
import {
  IconButton,
  useTheme,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  makeStyles,
  Dialog,
  Tooltip,
  Typography,
} from "@material-ui/core";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import Invite from "../Invite/invite";
import PlayRoom from "../Play/play"
import Media from "../mediaAnalysis/mediaAnalysis";
import axios from "axios";
import DeleteIcon from "@material-ui/icons/CallEnd";
import AddIcCallIcon from "@material-ui/icons/AddIcCall";
import { toast } from "react-toastify";
import PersonAddIcon from "@material-ui/icons/GroupAdd";
import Play from "@material-ui/icons/PlayArrow";
import "./table.css";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PermMediaIcon from "@material-ui/icons/PermMedia";

const columns = [
  { id: "rid", label: "Room Id", align: "center", maxWidth: 100 },
  { id: "name", label: "Name", align: "center", maxWidth: 100 },
  { id: "status", label: "Status", align: "center", maxWidth: 100 },
  { id: "action", label: "Action", align: "center", maxWidth: 100 },
];

const useStyles = makeStyles({
  button: {
    width: "100px",
    height: "34px",
    justifyContent: "center",
    textAlign: "center",
    margin: "auto",
    color: "#FFFF",
    marginTop: "3vh",
    marginBottom: "3vh",
    background: "#314B9F",
  },
});

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };
  console.log("count", count, page, rowsPerPage, onPageChange);
  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage)}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, status, action) {
  return { name, status, action };
}

const inviteHandler = () => {
  setInvite(true);
};

export default function CustomPaginationActionsTable({
  filter,
  data,
  setData,
  page,
  offset,
  rowsPerPage,
  setPage,
  setOffset,
  setRowsPerPage,
  sip,
  setList,
  makeCall
}) {
  const [invite, setInvite] = React.useState(false);
  const [play, setPlay] = React.useState(false);
  const [mediaAnalysis, setMediaAnalysis] = React.useState(false);
  const [roomId, setRoomId] = React.useState();
  const [inviteData, setInviteData] = React.useState();
  const [roomData, setRoomData] = React.useState({
    callerId: '', roomId: ''
  })
  const updatedUrl = localStorage.getItem("apiEndpoint");
  const baseURL = updatedUrl ? updatedUrl
    : window.config.apiEndpoint;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, roomtype, callerId, roomId) => {
    // if (roomtype.toLowerCase() !== "audio" )
      setAnchorEl(event.currentTarget);
      setRoomData({ callerId: callerId, roomId: roomId, roomtype: roomtype });
    // setRoomtype(event.target.value)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Avoid a layout jump when reaching the last page with empty rows.

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
    let queryParams = `?`;
    if (filter?.roomType) {
      queryParams = queryParams + `RoomType=${filter?.roomType}&`;
    }
    if (filter?.status) {
      queryParams = queryParams + `Status=${filter?.status}&`;
    }
    if (filter?.roomName) {
      queryParams = queryParams + `RoomName=${filter?.roomName}&`;
    }
    if (filter?.ClosedAt) {
      queryParams = queryParams + `ClosedAt=${filter?.ClosedAt}&`;
    }
    if (filter?.CreatedAt) {
      queryParams = queryParams + `CreatedAt=${filter?.CreatedAt}&`;
    }
    if (rowsPerPage) {
      queryParams = queryParams + `Limit=${rowsPerPage}&`;
    }
    if (rowsPerPage * newPage) {
      queryParams = queryParams + `Offset=${rowsPerPage * newPage}&`;
    }
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId =
      localStorage.getItem("accountId") || window.config?.accountId;
    axios
      .get(`${baseURL}/accounts/${acId}/room${queryParams}`, {
        headers: headers,
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    let queryParams = `?`;
    if (filter?.roomType) {
      queryParams = queryParams + `RoomType=${filter?.roomType}&`;
    }
    if (filter?.status) {
      queryParams = queryParams + `Status=${filter?.status}&`;
    }
    if (filter?.roomName) {
      queryParams = queryParams + `RoomName=${filter?.roomName}&`;
    }
    if (filter?.ClosedAt) {
      queryParams = queryParams + `ClosedAt=${filter?.ClosedAt}&`;
    }
    if (filter?.CreatedAt) {
      queryParams = queryParams + `CreatedAt=${filter?.CreatedAt}&`;
    }
    if (offset) {
      queryParams = queryParams + `Offset=${offset}&`;
    }
    queryParams = queryParams + `Limit=${parseInt(event.target.value, 10)}&`;
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    axios
      .get(`${baseURL}/accounts/${acId}/room${queryParams}`, {
        headers: headers,
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setPage(0);
  };
  // console.log("page",page)
  React.useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    axios
      .get(
        `${baseURL}/accounts/${acId}/room?Status=CREATED,RESERVED&Limit=${rowsPerPage}&Offset=${offset}`,
        {
          headers: headers,
        }
      )
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
  }, []);

  const handleDelete = (roomId) => {
    let queryParams = `?`;
    if (filter?.roomType) {
      queryParams = queryParams + `RoomType=${filter?.roomType}&`;
    }
    if (filter?.status) {
      queryParams = queryParams + `Status=${filter?.status}&`;
    }
    if (filter?.roomName) {
      queryParams = queryParams + `RoomName=${filter?.roomName}&`;
    }
    if (filter?.ClosedAt) {
      queryParams = queryParams + `ClosedAt=${filter?.ClosedAt}&`;
    }
    if (filter?.CreatedAt) {
      queryParams = queryParams + `CreatedAt=${filter?.CreatedAt}&`;
    }
    if (rowsPerPage) {
      queryParams = queryParams + `Limit=${rowsPerPage}&`;
    }
    if (offset) {
      queryParams = queryParams + `Offset=${offset}&`;
    }
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    axios
      .delete(`${baseURL}/accounts/${acId}/room/${roomId}`, {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
        toast.success("Room Closed");

      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setTimeout(() => {
      axios
        .get(`${baseURL}/accounts/${acId}/room${queryParams}`, {
          headers: headers,
        })
        .then(function (response) {
          setData(response.data);
        })
        .catch(function (error) {
          console.log(error);
          toast.error("Failed, StatusCode:" + error?.response?.data?.message);
        })
    }, 1000);
  };

  const joinCall = (roomId, roomType, callerId) => {
    // if (!callerId) {
    //   toast.error("CallerId Doesn't Exist")
    // } else 
    if (callerId !== undefined && roomType&&roomType.toLowerCase() === "audio") {
      const headers = {
        "Content-Type": "application/json",
        apikey: localStorage.getItem("apikey") || window.config.apikey,
      };
      const acId = localStorage.getItem("accountId") || window.config?.accountId;
      const requestBody = {
        From: callerId,
        To: sip,
        Type: "voice",
        Eml: `<Response>\r\n<Dial>\r\n<Conference>${roomId}<\/Conference>\r\n<\/Dial>\r\n<\/Response></RID>`
      };
      axios
        // .post(`${baseURL}/accounts/${acId}/room/${roomId}/join`, requestBody, {
        .post(`${baseURL}/accounts/${acId}/call`, requestBody, {
          headers: headers,
        })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
          toast.error("Failed, StatusCode:" + error?.response?.data?.message);
        });
    }
  };

  const onCopyClick = (rid) => {
    navigator.clipboard.writeText(rid);
    toast.success("RoomId Copied")
  }
  const onSelectRoomtype = (e, type) => {
      if (type === "voice") {
       makeCall({
          audio: true,
          video: false,
          remoteURI: `conf:${roomData?.roomId}`,
        });
        setList(false);
        return;
      }
      if (type === "video") {
       makeCall({
          audio: true,
          video: true,
          remoteURI: `conf:${roomData?.roomId}`,
        });
            setList(false);
            return;
      }
    // {
    // const headers = {
    //   "Content-Type": "application/json",
    //   apikey: localStorage.getItem("apikey") || window.config.apikey,
    // };
    // const acId = localStorage.getItem("accountId") || window.config?.accountId;
    // const requestBody = {
    //   From: roomData.callerId,
    //   To: sip,
    //   Type: type,
    //   Eml: `<Response>\r\n<Dial>\r\n<Conference>${roomData.roomId}<\/Conference>\r\n<\/Dial>\r\n<\/Response></RID>`,
    // };
    // axios
    //   // .post(`${baseURL}/accounts/${acId}/room/${roomId}/join`, requestBody, {
    //   .post(`${baseURL}/accounts/${acId}/call`, requestBody, {
    //     headers: headers,
    //   })
    //   .then(function (response) {
    //     console.log(response);
    //     setList(false);
    //     // toast.success("Api call success");
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //     toast.error("Failed, StatusCode:" + error?.response?.data?.message);
    //   });
    // }
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table
        // stickyHeader={true}
        // aria-label="sticky table"
        // sx={{ height: 140, overFlow: "auto" }}
        >
          <TableHead style={{ background: "#c2ced8" }}>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ maxWidth: column.maxWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tablebody">
            {data?.rdrDtoList
              // ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row, id) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.code}
                    style={{ padding: "8px" }}
                  >
                    <>
                      {/* <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell> */}
                      <TableCell align="center" style={{ padding: "8px" }}>
                        <div style={{ display: "flex" }}>
                          <Tooltip title={row.id}>
                            <Typography>{row.id.slice(0, 10)}...</Typography>
                          </Tooltip>
                          <Tooltip title="Copy">
                            <FileCopyIcon
                              color="inherit"
                              onClick={() => onCopyClick(row.id)}
                            />
                          </Tooltip>
                        </div>
                      </TableCell>
                      <TableCell align="center" style={{ padding: "8px" }}>
                        {row.roomName}
                      </TableCell>
                      <TableCell align="center" style={{ padding: "8px" }}>
                        {row.status}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ padding: "8px", width: "160px" }}
                      >
                        <Tooltip title="Invite">
                          <span>
                            <IconButton
                              disabled={
                                row.status === "CLOSED" ||
                                row.status === "RESERVED"
                              }
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                setInvite(true);
                                setInviteData({
                                  roomId: row.id,
                                  roomType: row.roomType,
                                  callerId: row.callerId,
                                });
                              }}
                            >
                              <PersonAddIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Self Join">
                          <span>
                            <IconButton
                              disabled={row.status === "CLOSED"}
                              variant="outlined"
                              size="small"
                              onClick={(e) => {
                                handleClick(
                                  e,
                                  row.roomType,
                                  row.callerId,
                                  row.id
                                );
                              }}
                            >
                              <AddIcCallIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Close Room">
                          <span>
                            <IconButton
                              // variant="outlined"
                              size="small"
                              disabled={row.status === "CLOSED"}
                              onClick={() => {
                                handleDelete(row.id);
                              }}
                              style={{
                                marginLeft: "1%",
                              }}
                            >
                              <DeleteIcon
                                color={row.status === "CLOSED" ? "" : "error"}
                                disabled={row.status === "CLOSED"}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Play">
                          <span>
                            <IconButton
                              // variant="outlined"
                              size="small"
                              disabled={
                                row.status === "CLOSED" ||
                                row.status === "RESERVED"
                              }
                              onClick={() => {
                                setPlay(true);
                                setRoomId(row.id);
                              }}
                              style={{
                                marginLeft: "1%",
                              }}
                            >
                              <Play
                                color={
                                  row.status === "CLOSED" ||
                                  row.status === "RESERVED"
                                    ? ""
                                    : "primary"
                                }
                                disabled={
                                  row.status === "CLOSED" ||
                                  row.status === "RESERVED"
                                }
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="MediaAnalysis">
                          <span>
                            <IconButton
                              // variant="outlined"
                              size="small"
                              disabled
                              // ={row.status === "CLOSED"}
                              onClick={() => {
                                setMediaAnalysis(true);
                                setRoomId(row.id);
                              }}
                              style={{
                                marginLeft: "1%",
                              }}
                            >
                              <PermMediaIcon
                                color={row.status === "CLOSED" ? "" : ""}
                                disabled={true}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          // value={roomtype}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem
                            onClick={(e) => {
                              onSelectRoomtype(e, "voice");
                              handleClose();
                            }}
                            value="voice"
                          >
                            Audio
                          </MenuItem>
                          <MenuItem
                            onClick={(e) => {
                              onSelectRoomtype(e, "video");
                              handleClose();
                            }}
                            value="video"
                            disabled={
                              roomData?.roomtype?.toLowerCase() === "audio"
                            }
                          >
                            Video
                          </MenuItem>
                        </Menu>
                      </TableCell>
                      {/* <TableCell align="left">abc</TableCell> */}
                      {/* <TableCell><Button>Delete</Button></TableCell> */}
                    </>
                  </TableRow>
                );
              })}
          </TableBody>
          {data && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  // colSpan={3}
                  count={data?.meta?.totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  // SelectProps={{
                  //   inputProps: {
                  //     "aria-label": "rows per page",
                  //   },
                  //   native: true,
                  // }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  // ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
      <Dialog
        onClose={() => {
          setInvite(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={invite}
      >
        {invite && (
          <Invite
            setDailog={setInvite}
            inviteData={inviteData}
            sip={sip}
            setList={setList}
          />
        )}
      </Dialog>
      <Dialog
        onClose={() => {
          setPlay(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={play}
      >
        {play && <PlayRoom setDailog={setPlay} roomId={roomId} />}
      </Dialog>
      <Dialog
        onClose={() => {
          setMediaAnalysis(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={mediaAnalysis}
      >
        {" "}
        {mediaAnalysis && (
          <Media setDailog={setMediaAnalysis} roomId={roomId} />
        )}
      </Dialog>
    </>
  );
}
CustomPaginationActionsTable.propTypes = {
  filter: PropTypes.any,
  data: PropTypes.any,
  setData: PropTypes.any,
  page: PropTypes.any,
  offset: PropTypes.any,
  rowsPerPage: PropTypes.any,
  setPage: PropTypes.any,
  setOffset: PropTypes.any,
  setRowsPerPage: PropTypes.any,
  sip: PropTypes.any,
  setList: PropTypes.any,
  makeCall: PropTypes.any,
  // data: PropTypes.any,
};
